export enum widgetPlacementTypes {
  OWN_PAGE = 'OwnPage',
  RIGHT_OF_OVERVIEW = 'RightOfOverview',
  RIGHT_OF_CALENDAR = 'RightOfCalendar',
  BELOW_CALENDAR = 'BelowCalendar',
  NOTICE_BOARD = 'NoticeBoard',
}
